export { NEW_JOURNEY_NOTIFICATION_MODAL_PT_BR } from "./new-journey-notification-modal-pt-br";
export { NEW_JOURNEY_NOTIFICATION_MODAL_EN_US } from "./new-journey-notification-modal-en-us";
export { NEW_JOURNEY_NOTIFICATION_MODAL_ES_MX } from "./new-journey-notification-modal-es-mx";
export { NEW_JOURNEY_NOTIFICATION_MODAL_FR_FR } from "./new-journey-notification-modal-fr-fr";
export type { NewJourneyNotificationModalTranslations } from "./new-journey-notification-modal-pt-br";
